import {createBrowserHistory} from 'history';

export default createBrowserHistory();



// WEBPACK FOOTER //
// ./app/config/history.ts